/**
 * Reach the driver who is on a trip — a WhatsApp message and a call, from
 * wherever the dispatcher's screens name them: a driver's group on the
 * board, and the Crew card on the trip screen.
 *
 * The links are the portal's own (`whatsappUrl` / `telUrl`, the same two the
 * customer card and the admin's portal-access hand-over use), so there is
 * one place that knows how to turn a number into a chat or a call.
 *
 * MESSAGE FIRST, then call: this office reaches drivers on WhatsApp, which
 * is what every driver-facing screen in the portal already says, and a call
 * is the fallback rather than the habit.
 *
 * `lead` SAYS THE TWO ARE NOT EQUALS. A board row is a list of twenty trips
 * and gives both the same small chip, because the row itself is the thing
 * being scanned. The TRIP screen is one trip being dealt with, usually
 * one-handed and usually in a hurry, and there Message is the widest, most
 * reachable control on the card while Call sits beside it at its natural
 * width: the habit is big, the exception is not hidden. Neither changes what
 * it does, only how much of the thumb's reach it claims.
 *
 * A trip with no driver, or a driver with no number on file, renders
 * NOTHING — never a control that goes nowhere. (The API leaves
 * `driver.phone_number` out for a driver it has no number for.)
 */
import React from 'react';
import { telUrl, whatsappUrl } from '../../../Utils/contactLinks';
import { PhoneIcon, WhatsAppIcon } from '../Components/Icons';

export default function DriverContact({ name = '', phone = '', lead = false }) {
  if (!phone) return null;

  const who = name ? ` ${name}` : '';
  // 44px either way — `--contact` is 48 and `--sm` only narrows the padding,
  // so the quieter one is no harder to hit, only less wide.
  const size = lead ? 'pp-btn--contact' : 'pp-btn--sm';

  return (
    <div className={`pp-dispatch__contact${lead ? ' pp-dispatch__contact--lead' : ''}`}>
      <a
        className={`pp-btn ${size} pp-btn--whatsapp${lead ? ' pp-btn--grow' : ''}`}
        href={whatsappUrl(phone)}
        target="_blank"
        rel="noreferrer"
        aria-label={`Message${who} on WhatsApp`}
      >
        <WhatsAppIcon size={lead ? 18 : 16} />
        Message
      </a>
      <a
        className={`pp-btn ${size} pp-btn--outline`}
        href={telUrl(phone)}
        aria-label={`Call${who}`}
      >
        <PhoneIcon size={lead ? 18 : 16} />
        Call
      </a>
    </div>
  );
}
